<!--
 * @Author: yuka
 * @Date: 2019-07-31 16:45:20
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 16:01:01
 * @Description: 
 -->
<template>
  <div class="m-footer-wrapper">
    <!-- <div class="btn-box">
      <img src="../assets/images/down-btn.png" alt="" class="down-btn" @click="download">
    </div> -->
    <div class="m-footer-box">
      <div class="row">
        <p class="m-contract-way">咨询电话：10102015</p>
        <p>商务合作：BD@jinr.com</p>
      </div>
      <div class="row">
        <p class="m-postcode">邮编：361000</p>
        <!-- <p class="m-phone">举报电话：0592-5333029</p> -->
      </div>
    </div>
    <div class="m-icon-wrapper">
      <img src="https://files.jinr.com/jinr-index/img/footer-icon-01.png" alt="" srcset="" />
      <img src="https://files.jinr.com/jinr-index/img/footer-icon-02.png" alt="" srcset="" />
      <img src="https://files.jinr.com/jinr-index/img/footer-icon-03.png" alt="" srcset="" />
      <img src="https://files.jinr.com/jinr-index/img/footer-icon-04.png" alt="" srcset="" />
      <a class="lz-img" target="_blank" href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91350205302896797R-SAIC_SHOW_10000091350205302896797R1738935768893&signData=MEYCIQDaD5CLGdgLm/jzSoQvgYmKQoK9lB5yJ30O9o/e9+rDCAIhAISiDMEmJsoAOLNXG56g1zUXXvU8QTdyoLNiH/X9i8wM">
        <img src="../assets/images/lz4.png" alt="">
      </a>
    </div>
    <p class="m-copyright">
      <span>
        厦门吉才神网络借贷信息中介服务有限公司&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer"
          >闽ICP备14014561号-2</a
        >
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'index-footer',
  methods:{
    download(){
      const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // iOS 终端
      let downloadUrl = isIOS ? 
      'https://apps.apple.com/cn/app/%E9%B2%B8%E9%B1%BC-%E4%B8%BA%E6%82%A8%E6%8F%90%E4%BE%9B%E4%B8%93%E4%B8%9A%E7%9A%84%E6%9C%8D%E5%8A%A1/id937122028'
      : 'https://jinrapk.oss-cn-hangzhou.aliyuncs.com/apk/1.0.0/jinrmax_release_20250618-090923_v1.0.00_1000_jiagu_aligned_signed_maxguanwang.apk';
      
      window.open(downloadUrl,'_blank')
    }
  }
};
</script>
<style lang="less" scoped>
.m-footer-wrapper {
  font-size: 0.18rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0;
  color: #8795a8;
  background: #212940;
  font-family: 'PingFangSC-Regular';
  text-align: center;
  padding: 0.25rem 0 0.19rem;
}
.btn-box{
  .down-btn{
    display: block;
    width:2.81rem;
    margin:0 auto 0.25rem;
  }
}


.m-copyright {
  // transform: scale(0.8);
  font-family: 'PingFangSC-Regular';
  a {
    color: #8795a8;
  }
}
.m-footer-box {
  margin: 0 auto;
  display: table;
  text-align: left;
  .row {
    display: table-row;
    p {
      display: table-cell;
      padding: 0 0.15rem 0.17rem;
    }
  }
  // flex-wrap: wrap;
  // justify-content: space-around;
}
.m-icon-wrapper {
  margin: 0 0 0.3rem;
  img {
    height: 0.33rem;
    margin: 0 0.08rem;
  }
}
</style>
